import React, { useEffect, useState } from 'react';
import QuizScale from '@anu/components/QuizScale';
import PropTypes from 'prop-types';
import {
  getStoredQuestion,
  setStoredQuestion,
} from '../utilities/session.question';
import { coursePropTypes } from '@anu/utilities/transform.course';

/**
 * Extends original `QuizScaleAdapter` to support private sessions.
 */

const ERROR_MESSAGE =
  'Could not submit the response. Please, refresh the page and try again or contact the administrator.';

const showError = (status, responseText) => {
  alert(ERROR_MESSAGE);
  return console.error(status, responseText);
};

const QuizScaleAdapter = (props) => {
  const defaultValue = Math.round((props.scale.from + props.scale.to) / 2);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    // During the initialization set the default value for the widget.
    if (props.isQuiz) {
      props.onChange(defaultValue);
    }
    // Check user session for lessons.
    else if (props.course && props.course.private_sessions) {
      const submittedAnswer = getStoredQuestion(props.aqid);;
      if (
        typeof submittedAnswer === 'number'
        && props.scale.from <= submittedAnswer <= props.scale.to
      ) {
        setValue(submittedAnswer);
        setIsSubmitted(true);
        props.onQuestionComplete(props.aqid);
      }
    }
  }, []);

  const onChange = (event, value) => {
    props.onChange(value);
    setValue(value);

    setStoredQuestion(props.aqid, value);
    setIsSubmitted(true);
    props.onQuestionComplete(props.aqid);
  };

  return (
    <QuizScale
      question={props.question}
      scale={props.scale}
      value={props.submittedAnswer || value}
      correctValue={props.correctQuizValue}
      isSubmitting={props.isSubmitting}
      isSubmitted={props.isSubmitted || isSubmitted}
      onChange={onChange}
    />
  );
};

QuizScaleAdapter.propTypes = {
  course: coursePropTypes,
  aqid: PropTypes.number,
  question: PropTypes.string,
  scale: PropTypes.object,
  value: PropTypes.number,
  defaultValue: PropTypes.number,
  correctQuizValue: PropTypes.number,
  isSubmitting: PropTypes.bool,
  isSubmitted: PropTypes.bool,
  onSubmit: PropTypes.func,
  onChange: PropTypes.func,
  onQuestionComplete: PropTypes.func,
  isQuiz: PropTypes.bool,
  submittedAnswer: PropTypes.number,
};

QuizScaleAdapter.defaultProps = {
  onSubmit: () => {},
  onChange: () => {},
  onQuestionComplete: () => {},
  submittedAnswer: null,
};

export default QuizScaleAdapter;
